/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { CompanyService } from '../../services/company.service';
import { PartnerService } from '../../../partners/services/partner.service';
import { IPartner, IListByFilterParceiros } from '../../../partners/models/partner.interface';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { ToastService } from 'src/app/shared/services/toast.service';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { th } from 'date-fns/locale';
import { SessionService } from 'src/app/shared/services/session.service';

@Component({
  selector: 'app-add-new-company',
  templateUrl: './add-new-company.component.html',
  styleUrls: ['./add-new-company.component.scss']
})
export class AddNewCompanyComponent {
  ERoleAdminString = ERoleAdminString;
  @Output() recarregarListagem = new EventEmitter();
  formAberto = false;

  formCompany = new UntypedFormGroup({
    name: new UntypedFormControl('', [Validators.required]),
    trading: new UntypedFormControl(''),
    document: new UntypedFormControl('', [Validators.required]),
    type: new UntypedFormControl(null, [Validators.required]),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    phone: new UntypedFormControl('', [Validators.required]),
    logo: new UntypedFormControl(''),
    partnerId: new UntypedFormControl(null, [Validators.required])
  });

  opcoesTipoCompany: string[] = [];
  partners: any = [];

  imageFile?: { link: string; file: any; name: string; base64: string };
  imagemCarregada = false;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly companyService: CompanyService,
    private readonly toastService: ToastService,
    private readonly partnerService: PartnerService,
    private readonly sessionService: SessionService
  ) {
    this.opcoesTipoCompany = this.companyService.opcoesTipoEmpresa;
  }

  ngOnInit(): void {
    this.carregarParceiros();
  }

  public salvarCompany(): void {
    if (this.formCompany.invalid) {
      this.toastService.toast('Preencha todos os campos obrigatórios antes de salvar.', EMessageType.Error);
      this.formCompany.markAllAsTouched();
      return;
    }

    if (this.formCompany.valid) {
      this.companyService.adicionarEmpresa(this.formCompany.getRawValue()).subscribe((resposta) => {
        if (resposta.messages && resposta.messages.length > 0) {
          this.toastService.toast(resposta.messages);
        }

        if (resposta.isSucceed) {
          //MAYBE: possivel call para AWS s3 no futuro
          // this.salvarImagem(resposta.data);
          this.formAberto = false;
          this.formCompany.reset();
          this.imageFile = undefined;
          this.imagemCarregada = false;
          this.recarregarListagem.emit();
        }
      });
    }
  }

  //MAYBE: provavelmente será alterado para enviar a imagem ao bucket AWS
  public salvarImagem(companyId: string): void {
    if (!this.imageFile) return;

    const imagemFormData = new FormData();

    imagemFormData.append('id', companyId);
    imagemFormData.append('image', this.imageFile.file);

    this.companyService.adicionarImagemEmpresa(imagemFormData).subscribe((resposta) => {
      if (resposta.messages && resposta.messages.length > 0) {
        this.toastService.toast(resposta.messages);
      }
    });
  }

  public onImageInput(evento: Event): void {
    const { files } = evento.target as HTMLInputElement;

    if (files && files.length > 0) {
      const reader = new FileReader();

      reader.readAsDataURL(files[0]);

      reader.onload = (_event: any) => {
        this.imageFile = {
          link: _event.target.result,
          file: files[0],
          name: files[0].name,
          base64: reader.result!.toString().split(',')[1]
        };

        this.formCompany.get('logo')!.patchValue(this.imageFile.base64);

        this.imagemCarregada = true;
        this.cdr.markForCheck();
      };
    }
  }

  carregarParceiros(): void {
    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    if (partnerId) {
      this.partnerService.getPartnerById(partnerId).subscribe((resposta) => {
        this.partners = [resposta.data];
        this.formCompany.get('partnerId')?.patchValue(partnerId);
        this.formCompany.get('partnerId')?.disable();
      });
    } else {
      const filtros: IListByFilterParceiros = {
        orderBy: Number(EOrdenacao.AlfabeticaAZ),
        pageNumber: 0,
        pageSize: 9999
      };

      if (partnerId) {
        filtros.partnerId = partnerId;
      }

      if (companyId) {
        filtros.companyId = companyId;
      }

      if (accountRole) {
        filtros.accountRole = parseInt(accountRole);
      }

      this.partnerService.listarTodosParceiros(filtros).subscribe((resposta) => {
        this.partners = resposta.data;
      });
    }
  }
}
